var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbcPeopleCounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14161_103988)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_14161_103988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 11H20.5C16.0817 11 12.5 14.5817 12.5 19V59C12.5 63.4183 16.0817 67 20.5 67H59.5C63.9183 67 67.5 63.4183 67.5 59V19C67.5 14.5817 63.9183 11 59.5 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 12.5H20.5C16.9101 12.5 14 15.4101 14 19V59C14 62.5899 16.9101 65.5 20.5 65.5H59.5C63.0899 65.5 66 62.5899 66 59V19C66 15.4101 63.0899 12.5 59.5 12.5Z",
    stroke: "#FF8027",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 44.174H53.134C53.1371 42.6949 52.6041 41.2647 51.6338 40.1483C50.6635 39.0319 49.3215 38.3049 47.8563 38.1019C46.3911 37.899 44.902 38.2338 43.6648 39.0444C42.4275 39.8549 41.5258 41.0864 41.1267 42.5107C42.6402 43.4563 43.8887 44.7709 44.7548 46.3313C45.6209 47.8916 46.0764 49.6464 46.0784 51.431H44.2123V51.4075C44.2085 49.1077 43.2914 46.9036 41.6628 45.2798C40.0341 43.656 37.8272 42.7456 35.5274 42.7487C33.2276 42.7518 31.0232 43.6682 29.399 45.2964C27.7747 46.9246 26.8636 49.1312 26.8661 51.431H25C24.9969 49.7097 25.4161 48.014 26.2209 46.4925C27.0258 44.971 28.1917 43.6702 29.6163 42.7042C31.041 41.7382 32.6809 41.1365 34.3923 40.952C36.1036 40.7674 37.8341 41.0056 39.432 41.6456C40.0308 39.8445 41.2514 38.3156 42.875 37.3326C44.4986 36.3497 46.4192 35.9769 48.2926 36.2812C50.166 36.5855 51.8699 37.5469 53.099 38.9931C54.328 40.4394 55.0019 42.2761 55 44.174ZM42.6938 30.8788C42.6938 30.0264 42.9466 29.1931 43.4202 28.4844C43.8937 27.7756 44.5669 27.2232 45.3544 26.8969C46.142 26.5707 47.0085 26.4854 47.8446 26.6517C48.6807 26.818 49.4486 27.2284 50.0514 27.8312C50.6542 28.4339 51.0647 29.2019 51.231 30.0379C51.3973 30.874 51.3119 31.7406 50.9858 32.5281C50.6596 33.3157 50.1071 33.9888 49.3984 34.4624C48.6896 34.936 47.8563 35.1888 47.0039 35.1888C46.4379 35.1889 45.8774 35.0774 45.3545 34.8608C44.8316 34.6442 44.3564 34.3267 43.9562 33.9265C43.556 33.5263 43.2385 33.0512 43.0219 32.5282C42.8053 32.0053 42.6938 31.4449 42.6938 30.8788ZM44.5688 30.8788C44.5688 31.3604 44.7116 31.8312 44.9792 32.2317C45.2467 32.6321 45.627 32.9442 46.0719 33.1285C46.5169 33.3128 47.0065 33.361 47.4788 33.2671C47.9512 33.1731 48.385 32.9412 48.7256 32.6007C49.0661 32.2602 49.298 31.8263 49.392 31.354C49.486 30.8816 49.4378 30.392 49.2535 29.9471C49.0692 29.5021 48.7571 29.1218 48.3567 28.8543C47.9563 28.5867 47.4855 28.4439 47.0039 28.4438C46.3583 28.4446 45.7394 28.7013 45.2829 29.1578C44.8264 29.6143 44.5696 30.2333 44.5688 30.8788ZM30.013 34.1669C30.013 33.074 30.3371 32.0056 30.9443 31.0969C31.5515 30.1881 32.4146 29.4798 33.4243 29.0616C34.4341 28.6434 35.5452 28.5339 36.6171 28.7471C37.689 28.9604 38.6737 29.4867 39.4465 30.2595C40.2193 31.0323 40.7456 32.0169 40.9588 33.0889C41.172 34.1608 41.0626 35.2719 40.6444 36.2816C40.2261 37.2914 39.5179 38.1544 38.6091 38.7616C37.7004 39.3688 36.632 39.6929 35.5391 39.6929C34.8134 39.6929 34.0948 39.55 33.4243 39.2723C32.7539 38.9946 32.1447 38.5876 31.6316 38.0744C31.1184 37.5613 30.7114 36.9521 30.4337 36.2816C30.156 35.6112 30.013 34.8926 30.013 34.1669ZM31.888 34.1669C31.888 34.889 32.1021 35.5949 32.5033 36.1953C32.9045 36.7957 33.4747 37.2637 34.1418 37.54C34.8089 37.8164 35.543 37.8887 36.2512 37.7478C36.9595 37.607 37.61 37.2593 38.1206 36.7487C38.6312 36.2381 38.979 35.5875 39.1198 34.8793C39.2607 34.1711 39.1884 33.437 38.9121 32.7699C38.6358 32.1027 38.1678 31.5325 37.5674 31.1313C36.967 30.7301 36.2612 30.516 35.5391 30.516C34.5711 30.517 33.6431 30.902 32.9586 31.5865C32.2741 32.2709 31.8891 33.1989 31.888 34.1669Z",
    fill: "#FF8027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14161_103988",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_14161_103988",
    x: 0.5,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14161_103988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14161_103988",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_14161_103988"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbcPeopleCounting);
export default __webpack_public_path__ + "static/media/EBC-people-counting.a78ba2669b2bf0d4a68ead2af604047a.svg";
export { ForwardRef as ReactComponent };